
class Callback {
    f: (args: any) => void;
    singleShot: boolean;
}

/**
 * Wrapper to native callbacks via the 'window' object.
 */
class CallbacksManager {

    private _cbs: {[key: string]: Callback[]} = {};

    /**
     * Install a native callback.
     * @param {string} event the name of the event
     * @param {(args: any) => void} f the callback function
     * @param {boolean} singleShot true if the callback should only be fired once
     */
    setCallback(event: string, f: (args: any) => void, singleShot: boolean = true) {

        if (! (window as any).onNativeCallback) {
            throw "Must call install() first";
        }

        let cb = new Callback();
        cb.f = f;
        cb.singleShot = singleShot;
        this._cbs[event] = this._cbs[event] || [];
        this._cbs[event].push(cb);
    }

    install () {
        (window as any).onNativeCallback = (event, args) => this.fireCallback(event, args);
    }

    fireCallback(event: string, args: any) {

        console.log('Firing event: ' + event);
        let cbs = this._cbs[event] || [];

        for (let cb of cbs) {
            try {
                cb.f(args);
            } catch (e) {
                console.log("Could not execute callback for event " + event, e);
            }
        }

        // remove one-shot callbacks
        this._cbs[event] = cbs.filter((x) => !x.singleShot);
    }
}

let NativeCallbacks = new CallbacksManager();
export {NativeCallbacks};



// WEBPACK FOOTER //
// ../lib/src/Callbacks.ts